import { CustomCellEditorProps } from 'ag-grid-react';
import { noop } from 'lodash-es';
import {
  FieldCellEditor,
  FieldCellEditorProps,
} from '../../../components/AgTable/cell-editors/FieldCellEditor';

// closing the calendar popup must not end the edit - only Enter commits a draft
export function ReservesDraftDateCellEditor(props: CustomCellEditorProps & FieldCellEditorProps) {
  return <FieldCellEditor {...props} stopEditing={noop} />;
}
